module.exports = __webpack_public_path__ + "static/media/Test_image.648e6421.png";